import {
  AutoGraph,
  FilterTiltShiftOutlined,
  GroupsOutlined,
  InterestsOutlined,
  PeopleOutlineOutlined,
  PolylineOutlined,
  Search,
  SettingsOutlined,
  ShoppingBagOutlined,
  SmsOutlined,
  TrackChangesOutlined,
  TryOutlined,
} from '@mui/icons-material';
import { Permission } from '@procureai/permissions';
import { useMemo } from 'react';

import { NavId, NavItemConfig, FeatureFlag } from '~/common/types';
import { RouteId } from '~/routes';

export const useAppNavBarConfig = (): NavItemConfig[] => {
  const createNavItemConfig = (config: NavItemConfig): NavItemConfig => config;

  return useMemo(() => {
    return [
      createNavItemConfig({
        id: NavId.cockpit,
        Icon: TryOutlined,
        to: RouteId.cockpit,
        needs: { permission: Permission.RouteCockpit },
      }),
      createNavItemConfig({
        id: NavId.search,
        Icon: Search,
        to: RouteId.search,
        needs: { permission: Permission.SearchView },
      }),
      createNavItemConfig({
        id: NavId.analytics,
        Icon: AutoGraph,
        to: RouteId.analyticsBase(''),
        needs: {
          permission: {
            any: [
              Permission.BaseGeneral,
              Permission.BaseOrderList,
              Permission.BaseCommodityList,
              Permission.BaseContractList,
              Permission.BaseRequisitionList,
              Permission.BaseSupplierList,
              Permission.AnalyticsView,
            ],
          },
        },
      }),
      createNavItemConfig({
        id: NavId.demand,
        Icon: ShoppingBagOutlined,
        to: RouteId.demand,
        needs: { permission: Permission.DemandList },
      }),
      createNavItemConfig({
        id: NavId.intake,
        Icon: SmsOutlined,
        to: RouteId.intake,
        needs: { permission: Permission.IntakeList },
      }),
      createNavItemConfig({
        id: NavId.demo,
        Icon: FilterTiltShiftOutlined,
        to: RouteId.demo,
        needs: { feature: FeatureFlag.DEMO },
      }),
      createNavItemConfig({
        id: NavId.riskSustainability,
        Icon: TrackChangesOutlined,
        to: RouteId.riskSustainability,
        needs: { feature: FeatureFlag.RISK_SUSTAINABILITY },
      }),
      createNavItemConfig({
        id: NavId.team,
        Icon: PeopleOutlineOutlined,
        to: RouteId.team,
        needs: { permission: Permission.UserAvailabilityListView },
      }),
      createNavItemConfig({
        id: NavId.teamManagement,
        Icon: GroupsOutlined,
        to: RouteId.teamManagement,
        needs: { permission: Permission.TeamManage },
      }),
      createNavItemConfig({
        id: NavId.dataFoundation,
        Icon: PolylineOutlined,
        to: RouteId.dataFoundation,
        needs: { permission: Permission.RouteFoundation },
      }),
      createNavItemConfig({
        id: NavId.settings,
        Icon: SettingsOutlined,
        to: RouteId.settings,
        needs: { permission: Permission.RouteSettings },
      }),
      createNavItemConfig({
        id: NavId.internalTools,
        Icon: InterestsOutlined,
        to: RouteId.internalTools,
        needs: { permission: Permission.RouteInternal },
      }),
    ];
  }, []);
};
